export default function useInvoiceStatus() {
  const english = [
    'UNPAID',
    'PAID',
  ];

  const thai = [
    'ยังไม่ชำระเงิน',
    'ชำระเงินแล้ว',
  ];

  const translate = (status: string) => thai[english.indexOf(status)];

  const invoiceStatusClassMap = (status: string) => {
    switch (status) {
      case 'UNPAID':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-red-500';
      case 'PAID':
        return 'block text-white rounded-xl text-xs py-1 text-center bg-green-500';
      default: return '';
    }
  };

  return {
    english,
    thai,
    translate,
    invoiceStatusClassMap,
  };
}
